export const trackAddToBag = (analytics, sizeSku) => {
    const { category = {} } = analytics.page;
    const selected = findItem(analytics?.productList?.item, sizeSku);
    const { index = null, item = null } = selected;

    return {
        event: 'add to cart',
        effect: 'update cart',
        attributes: {
            pageNumer: analytics.pageNumber,
            position: index,
        },
        category: {
            primaryCategory: category.primaryCategory,
            subCategory: category.subCategory1,
        },
        item: item ? [item] : null,
    };
};

const findItem = (items, sizeSku) => {
    return (
        items &&
        items.reduce((acc, item, index) => {
            if (item.productInfo?.sku == sizeSku) {
                acc.item = item;
                acc.index = index + 1;
            }
            return acc;
        }, {})
    );
};

export const trackGoToBag = (analytics) => {
    const subCategory = analytics?.page?.category?.subCategory1 || '';

    return {
        event: `proceed to purchase - from ${subCategory}`,
        effect: 'enter payment',
        category: {
            primaryCategory: 'payment',
            subCategory,
        },
        attributes: {
            position: 'pop-up',
        },
    };
};
